/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Acasă',
	myContent: 'Conţinutul meu',
	teamContent: 'Conţinut de echipă',
	folder: 'Folder',
	files: 'Fişiere',
	actionMenu: 'Meniul Acţiuni',
	myFolder: 'Folderele mele',

	emptyFolderNoContent: 'Niciun conţinut',

	//EmptyStates
	emptyRecentTitle: 'Nu aţi vizualizat niciun conţinut recent.',
	emptyStateTitle: 'Pornire prin adăugarea de date',
	emptyStateBody: 'Faceţi clic pe Încărcare date mai sus sau trageţi şi plasaţi pentru a încărca date.',
	emptySearchResultTitle: 'Hm, căutarea dumneavoastră nu a returnat niciun rezultat.',
	emptyPortalTitle: 'Niciun portal',
	emptyPortalBody: 'În prezent, nu aveţi niciun portal.',
	emptyWsProjectTitle: 'Începeţi prin crearea unui carnet în Watson Studio.',
	emptyWsProjectBody: 'Când reveniţi în Cognos Analytics, carnetul dumneavoastră va apărea aici.',
	emptyFilteredResultTitle: 'Hm, filtrele aplicate nu au returnat niciun rezultat.',
	emptyDialogViewTitle: 'Niciun articol',
	removeFromRecents: 'Înlăturare din Articole recente',

	// Welcome Banner
	welcomeBannerGreeting: 'Bună. Bine aţi venit la Cognos Analytics.',
	welcomeBannerDescription: 'Cognos Analytics le furnizează utilizatorilor unelte analitice cu autoservire, bazate pe AI. Vedeţi cum automatizarea pregătirii datelor, descoperirii datelor şi vizualizărilor poate conduce la decizii mai sigure.',
	welcomeBannerDescription_trialUser: 'Puteţi începe imediat, urmărind introducerea noastră video, parcurgând turul produsului şi examinând fila Iniţiere.',
	takeTourButtonLabel: 'Parcurgere turul produsului',
	watchVideoButtonLabel: 'Urmărire videoclip',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Sunteţi sigur că vreţi să dezactivaţi banner-ul de întâmpinare din pagina dumneavoastră Acasă? În orice moment, îl puteţi reactiva în Profil şi setări > Setări > General. ',
	hideWelcomeBannerTitle: 'Dezactivare banner de întâmpinare',
	ok: 'OK',
	cancel: 'Anulare',
	//howto video dialog
	modal_how_title: 'Videoclipuri Cum să',
	modal_overview_title: 'Urmărire prezentare generală Cognos Analytics',
	modal_how_play: 'Redare video',
	modal_how_video_title_overview: 'Privire generală',
	modal_how_video_title_getStarted: 'Iniţierea în 11.2',
	modal_how_video_title_newUI: 'Bine aţi venit la experienţa Cognos',
	modal_how_video_title_dataModule: 'Privire generală module de date',
	modal_how_video_title_explore: 'Privire generală explorare de date',
	modal_how_video_title_dashboard: 'Privire generală tablouri de bord interactive',
	modal_how_video_title_reporting: 'Privire generală Reporting',
	modal_how_video_title_mobile: 'Aveţi la îndemână o forţă numită Cognos',

	// Toolbar
	search: 'Căutare',
	addFolder: 'Adăugare folder',
	addLink: 'Adăugare legătură',
	filter: 'Filtru',
	sort: 'Sortare',
	settings: 'Setări',
	tilesView: 'Vizualizare de plăci',
	listView: 'Vizualizare listă',
	columnView: 'Vizualizare de coloane',

	// Toolbar Actions
	sortBy: 'Sortare după',
	sortOrder: 'Ordine',
	name: 'Nume',
	modifiedTime: 'Modificat',
	type: 'Tip',
	ascending: 'Crescător',
	descending: 'Descrescător',

	filterType: 'Tip',
	filterModificationTime: 'Modificat',
	all: 'Toate',
	today: 'Azi',
	yesterday: 'Ieri',
	pastWeek: 'Săptămâna trecută',
	pastMonth: 'Luna trecută',
	resetFilters: 'Resetare filtre',

	filterSearchPlaceHolder: 'Filtrare după cuvinte cheie',

	resetFilterTag: 'Faceţi clic pe X pentru a reseta filtrele.',
	filterTagToolTip: 'Filtre aplicate: %{appliedFilters}.',

	folderName: 'Nume folder',
	addAFolder: 'Adăugare folder',
	add: 'Adăugare',
	error: 'Eroare',
	newFolderDefaultName: 'Folder nou',
	toastCreateNewFolder: 'Folderul %{nameOfFolder} a fost creat în %{tabName}.',
	folderAdded: 'Folder adăugat',
	refresh: 'Reîmprospătare',
	openFolder: 'Deschidere folder',

	addAUrl: 'Adăugare URL',
	linkName: 'Nume URL',
	linkNamePlaceholder: 'Adăugare nume URL',
	linkDescription: 'Descriere (opţional)',
	linkDescriptionPlaceholder: 'Adăugaţi o descriere',
	linkUri: 'URL',
	linkUriPlaceholder: 'Adăugare URL cu domeniu acceptabil',
	acceptableDomains: 'Domenii acceptabile',
	viewAcceptableDomains: 'Vizualizare domenii acceptabile',
	mandatoryField: 'Câmp obligatoriu',
	linkAdded: 'URL adăugat',
	toastCreateNewLink: 'S-a adăugat %{nameOfLink} la %{tabName}.',
	noEntries: 'Nu există intrări în lista domeniilor acceptabile. Luaţi legătura cu administratorul.',

	compact: 'Compact',
	short: 'Scurt',
	default: 'Implicit',
	rowSize: 'Mărime rând',

	// GroupyByTypes
	folders: 'Foldere',
	reports: 'Rapoarte',
	dashboards: 'Tablouri de bord',
	data: 'Date',
	packages: 'Pachete',
	explorations: 'Explorări',
	stories: 'Poveşti',
	notebooks: 'Carnete',
	others: 'Altele',

	// Error Messages
	itemsOverLimit: 'Numele specificat "%{itemName}" depăşeşte limita maximă, (20). Pentru a continua, specificaţi alt nume.',
	errorMessageLengthFolderName: 'Vă rugăm introduceţi un nume de folder care nu depăşeşte 255 de caractere.',
	errorMessageLengthLinkName: 'Introduceţi un nume de legătură care să nu depăşească 255 de caractere.',
	toastLaunchPerspectiveError: 'Nu se poate deschide %{objectType}.',
	errorNoAccessTitle: 'Se pare că nu aveţi acces pentru la acest conţinut',
	errorNoAccessBody: 'Contactaţi-vă administratorul sau consultaţi legătura următoare:',
	errorEnableExternalContent: 'Activare conţinut extern',

	//TableHeader
	lastModified: 'Ultimul modificat',
	location: 'Locaţie',
	tenant: 'Chiriaş',

	// GetStartedTab
	getStartedLabel: 'Pregătirea pentru lucru în IBM Cognos Analytics',
	learningHowToLabel: 'Resurse de învăţare',
	learningHowToDescription: 'Vă conectaţi cu comunitatea, citiţi documentaţia şi urmăriţi videoclipuri pentru a vă extinde cunoştinţele şi a obţine asistenţă.',
	learningHowToActionLabel: 'Lansare panou de învăţare',
	howToVideosLabel: 'Videoclipuri Cum-să',
	howToVideosDescription: 'Aflaţi cum puteţi să utilizaţi IBM Cognos Analytics şi să începeţi extragerea insight-urilor din datele dumneavoastră.',
	howToVideosActionLabel: 'Urmărire videoclipuri',
	acceleratorCatalogLabel: 'Catalog Accelerator',
	acceleratorCatalogDescription: 'Răsfoiţi un catalog în continuă creştere, specific industriei, ghiduri pentru cele mai bune practici, vizualizări personalizate şi altele.',
	acceleratorCatalogActionLabel: 'Răsfoire catalog',
	sampleSectionTitle: 'Eşantioane',
	sampleSectionDescription: 'Experimentaţi cu exemple care evidenţiază ceea ce oferă Cognos Analytics.',
	// Samples Section
	createDashboardSampleTitle: 'Cum puteţi să creaţi primul dumneavoastră tablou de bord',
	createDashboardSampleDescription: 'Faceţi primii paşi către analiză cu Cognos Dashboards.',
	covid19SampleTitle: 'Tablou de bord COVID',
	covid19SampleDescription: 'Exploraţi arta posibilului cu acest tablou de bord Cognos ce analizează datele asociate cu COVID-19 şi extensii personalizate.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Expandaţi biblioteca de vizualizări cu vizualizări personalizate, cum ar fi Diagrama Sankey.',
	viewAllSamplesActionLabel: 'Vizualizare toate eşantioanele',
	byFeatureTitle: 'După caracteristică',
	byFeatureDescription: 'Răsfoiţi eşantioanele după caracteristică, cum ar fi funcţionalitatea de bază, controalele personalizate, extensiile, carnetele şi datele calendaristice relative. ',
	byIndustryTitle: 'După industrie',
	byIndustryDescription: 'Răsfoiţi eşantioanele după domeniu, cum ar fi industria auto, domeniu bancar şi multe altele. ',
	// SamplesTab
	sampleTabTitle: 'Inspiraţi-vă din eşantioanele noastre preconfigurate ',
	sampleTabLabel: 'Vizitaţi Accelerator Catalog pentru mai multe eşantioane şi extensii de la IBM, parteneri şi clienţi ',

	// quickLaunch
	quickLaunchLabel: 'Lansare rapidă',
	expand: 'Expandare',
	collapse: 'Restrângere',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Începeţi prin alegerea a ceea ce doriţi să creaţi.',

	// contentPageView
	contentPageTitleLabel: 'Conţinut',
	uploadFile: 'Încărcare date',
	new: 'Nou',
	create: 'Creare',
	more: 'Mai multe',

	// open dialog
	selectDataSourcesToAdd: 'Selectaţi sursa (sursele) de date de adăugat.',
	openDialogDefaultTitle: 'Deschidere',

	// save dialog
	save: 'Salvare',
	saveAs: 'Salvare ca',
	saving: 'Salvare...',
	selectedDestination: 'Destinaţie selectată: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' deja există cu alt tip. Alegeţi alt nume.',
	confirmOverwriteTitle: 'Confirmare înlocuire date existente',
	confirmOverwriteMsg: 'Fişierul \'%{nameOfFile}\' deja există. Doriţi să-i înlocuiţi datele cu cele din fişierul selectat?',

	// copy move dialog
	copy: 'Copiere',
	move: 'Mutare',
	copyOrMove: 'Copiere sau mutare: ',
	copyOnly: 'Copiere ',
	createShortcut: 'Creare scurtătură',
	createShortcutDialogTitle: 'Creare scurtătură: ',

	// External asset types
	wsProject: 'Proiect Watson Studio',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Pachet',
	dataModule: 'Modul de date',
	exploration: 'Explorare',
	mode: 'Mod',
	live: 'În direct',
	snapshot: 'Instantaneu',
	noSnapshotsFound: 'Nu a fost găsit niciun instantaneu',
	uploadedFile: 'Fişier încărcat',
	fileUpload: 'Încărcare date',
	dataSetEx: 'Set de date',
	externalRepository: 'Magazie externă',
	queryMode: 'Mod interogare',
	queryModeCompatible: 'Compatibil',
	queryModeDynamic: 'Dinamic',
	report: 'Raport',
	activeReport: 'Raport activ',
	query: 'Întrebare',
	analysis: 'Analiză',
	dashboard: 'Tablou de bord',
	dashboardTemplate: 'Şablon de tablou de bord',
	jupyterNotebook: 'Carnet',
	wsNotebook: 'Carnet Watson Studio',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Poveste',
	workspace: 'Spaţiu de lucru',
	pagelet: 'Pagină',
	content: 'Conţinut',
	directory: 'Spaţii de nume',
	dataSet: 'Set de date',
	powerPlayCube: 'Cub PowerPlay',
	powerPlayReport: 'Raport PowerPlay',
	powerPlay8Report: 'Raport PowerPlay',
	powerPlay8ReportView: 'Vizualizare raport PowerPlay',
	reportTemplate: 'Şablon raport',
	packageConfigurations: 'Configuraţie pachet',
	agent: 'Agent',
	agentDefinition: 'Definiţie agent',
	agentDefinitionView: 'Vizualizare agent',
	dataMovementTask: 'Task de mutare date',
	dataMovementTaskAlias: 'Alias task de mutare date',
	document: 'Document',
	DocumentRetention: 'Proprietăţi document',
	jobDefinition: 'Definiţie job',
	job: 'Job',
	metricsDataSourceETLTask: 'Task ETL sursă de date indici de măsurare',
	metricsExportTask: 'Task pentru export indici de măsurare',
	metricsFileImportTask: 'Task pentru import fişier indici de măsurare',
	metricsMaintenanceTask: 'Task pentru întreţinere indici de măsurare',
	planningTask: 'Task Planning',
	shortcut: 'Scurtătură',
	URL: 'URL',
	launchable: 'Lansabil',
	dataSetFolder: 'Folder set de date',
	ViewAccessibleLabel: 'Vizualizare %{label}',
	overrideReportOptions: 'Înlocuiţi opţiunile implicite de raportare',
	formats: 'Formate',
	saveReport: 'Salvare raport',
	promptForValues: 'Să fiu promptat',
	reportView: 'Vizualizare raport',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'Date Excel',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: 'Detalii',
	open: 'Deschidere',
	created: 'Creat',
	modified: 'Modificat',
	owner: 'Proprietar',
	dataSource: 'Sursă de date',
	share: 'Partajare',
	addToFavorites: 'Adăugare la Favorite',
	properties: 'Proprietăţi',
	detailsEmptyStateBody: 'Selectaţi un articol pentru a-i vizualiza detaliile.',
	editNameAndDescription: 'Editare nume şi descriere',
	none: 'Fără',

	//rename dialog
	nameInvalid: 'Numele nu este valid',
	namePlaceholder: 'Introduceţi un nume',
	description: 'Descriere',
	descriptionInvalid: 'Descrierea nu poate depăşi 350 de caractere.',
	descriptionPlaceholder: 'Introduceţi o descriere',
	errorMessageApostropheError: 'Vă rugăm introduceţi un nume de fişier care să nu conţină ambele caractere \' şi ".',
	renameCollisionError: '%{name} există deja. Încercaţi alt nume.',
	unknownRenameError: 'Redenumirea articolului a eşuat. Contactaţi administratorul pentru asistenţă suplimentară.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Nu se poate deschide folderul specificat.',

	//Upload
	uploadToFolder: "Încărcare în <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Încărcare în <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> şi lansare %{launchAction}",
	quickUpload: "Încărcare rapidă",
	quickUploadAndLaunch: "Trageţi şi plasaţi fişiere pentru a le încărca în <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> şi deschideţi într-unul din spaţiile următoare.",
	unsupportedFilesSingle: "%{files} nu s-a încărcat, deoarece nu este valid pentru Lansare rapidă.",
	unsupportedFilesMultiple: "Fişierele nu au fost încărcate, deoarece toate fişierele pe care selectaţi trebuie să fie valide pentru Lansare rapidă.",
	unsupportedFilesSingleInvalid: "%{files} este invalid.",
	unsupportedFilesMultipleInvalid: "%{files} sunt invalide.",
	supportedFileTypes: "Sunt permise numai următoarele tipuri de fişier: %{extensions}.",
	uploadDragAndDrop: "Tragere şi plasare",
	uploadDragAndDropMessage: "Trageţi şi plasaţi aici fişierul dumneavoastră pentru a-l încărca în <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Criteriile de căutare \'%{searchTerm}\' au fost salvate.',
	searchWasntSaved: 'Criteriile de căutare \'%{searchTerm}\' nu au fost salvate.',
	searchSuggestions: 'Sugestii',
	savedSearch: 'Căutări salvate',
	searchWasDeleted: 'Criteriile de căutare \'%{searchTerm}\' au fost şterse.',
	searchWasntDeleted: 'Criteriile de căutare \'%{searchTerm}\' nu au fost şterse.',
	savedBarTitle: 'Căutare Cognos Analytics',
	searchContentPageTitle: 'Căutare',
	searchContentPageTitleLabel: 'Sunt afişate rezultatele pentru \'%{searchTerm}\'',
	showingSearchRsult: 'Afişare %{resultCount} articole',
	saveSearch: 'Salvaţi căutarea',
	saveTenSearches: 'Puteţi salva 10 căutări.',
	deleteASearch: 'Ştergeţi una pentru a salva alta.',
	close: 'Închidere',

	//recent view
	recents: 'Recent',
	noAccessRecent: 'Fără acces',
	noAccessRecentMsg: 'Nu aveţi acces pentru acest activ. Este posibil să fi fost dezactivat sau şters sau permisiunile dumneavoastră să fi fost reduse. Verificaţi starea activului la locaţia sa sursă aşteptată. Puteţi să faceţi clic pe OK pentru a înlătura acest activ din articolele dumneavoastră recente.',
	noAccessMsg: 'Nu aveţi acces pentru acest activ. Este posibil să fi fost dezactivat sau şters sau permisiunile dumneavoastră să fi fost reduse.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} articole selectate',
	itemSelected: '%{nameOfSelection} articol selectat'

});